module.exports = __webpack_public_path__ + "img/744.58513184.jpg";